import React from 'react';

function attributeRow(label, attribute) {
  if (!attribute) return;
  return (
    <tr className="align-middle">
      <th className="text-nowrap" style={{ width: '1px' }}>{label}</th>
      <td>{attribute}</td>
    </tr>
  );
}

export default attributeRow;
